import { WhatWeOfferTypes } from '../WhatWeOfferTypes';
import { useThemeContext } from '../hooks/themeContext';
import { Column, Columns } from '@codeparva/ui-components-library';
import { weakKey } from '../../../../../../utilities/weakKey';
import React from 'react';
import { selectDescriptionColor } from '../helpers/getColorTheme';
import { getTextColor } from '../helpers/getColorTheme';
import { whatWeOfferConfig } from '../helpers/constants';
import { Icon } from '../../../../../../utilities/icomoon-css';
import { selectIconColor } from '../helpers/getColorTheme';

export const AmenitiesList = ({
  otherBenefitsIconDetails,
}: WhatWeOfferTypes.OtherBenfitsGallery) => {
  const currTheme = useThemeContext();

  return (
    <div className="otherBenefitsDetails has-text-left">
      {otherBenefitsIconDetails.map(otherBenefitsIconDetail => {
        const { icon, oneLineDescriptionDetails } = otherBenefitsIconDetail;
        return (
          <Columns key={weakKey(oneLineDescriptionDetails)}>
            <ul className="oneLineUnorderedList">
              <li key={weakKey(otherBenefitsIconDetail)}>
                <Column className="oneLineDescriptionColumn">
                  <div
                    className={`has-iconColor-${selectIconColor(currTheme)}`}
                  >
                    <Icon
                      name={icon.iconName}
                      size={whatWeOfferConfig.iconSize}
                    />
                  </div>
                  <span className="pt-4">
                    <h5>
                      <span
                        className={`has-text-${getTextColor(
                          currTheme
                        )} subTitleGalleryVariantForFeatures mb-1`}
                      >
                        {otherBenefitsIconDetail.title}
                      </span>
                    </h5>
                    <p
                      className={`oneLineDescriptionPara has-text-${selectDescriptionColor(
                        currTheme
                      )} pt-3`}
                    >
                      {oneLineDescriptionDetails.oneLineDescription}
                    </p>
                  </span>
                </Column>
              </li>
            </ul>
          </Columns>
        );
      })}
    </div>
  );
};
